import React, { forwardRef } from 'react'
import { dynamicSize } from '../../utils/hooks'
import {
  editablePropTypes,
  withEditableConverter,
} from '@linqpal/common-frontend/src/hooks'
import {
  AppInputBase,
  AppInputBaseProps,
} from '@linqpal/common-frontend/src/ui'

export const InputText = forwardRef((props: AppInputBaseProps, ref) => (
  <AppInputBase
    ref={ref}
    innerBorderStyle={{
      paddingLeft: dynamicSize(10),
      paddingRight: dynamicSize(5),
      paddingTop: dynamicSize(32),
      // paddingBottom: dynamicSize(16),
      lineHeight: dynamicSize(24),
    }}
    siblingProps={{
      marginRight: dynamicSize(10),
    }}
    {...props}
  />
))

const AppInputDynamic = withEditableConverter(InputText)
export const AppInputDynamicPadding: React.FC<
  AppInputBaseProps & editablePropTypes
> = React.memo(AppInputDynamic)
